import { DEFAULT_COLORS_BY_NAME, DEFAULT_GROUP_KEYS, DEFAULT_GROUP_LABELS, DEFAULT_SCALE_3_COLORS } from '@components/widgets/apacheEchart/Commons'
import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, msurPorcRespuestasMapper, msurTooltipTotalRegistros } from '../commonWidgetsMedicasur'
import { DEFAULT_COLORS } from '@components/widgets/apacheEchart/Commons'

export default {
    title: 'Experiencia hospitalización Dashboard',
    description: 'Dashboard de perfil Experiencia hospitalización',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        return [

            //THIS ADDS TWO WIDGETS TO SHOW AVERAGE GENERAL FOR SAT AND NPS 
            //CSAT GENERAL
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General',
                size: [2, 2],
                indicator: 'CSAT_GENERAL',
                criticalMomentInclude: [29],//this critical momenet id overwrits the others
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            //NPS GENERAL
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS General',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'NPS_GENERAL',
                criticalMomentInclude: [29],//this critical momenet id overwrits the others
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            // it shows summary for each critical moment for Satisfaction and NPS
            //Experiencia hospitalización
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - hospitalización',
                size: [2, 2],
                indicator: 'exp_hosp_csat',
                criticalMomentInclude: [10251],//experiencia hospitalizacion id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - hospitalización',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'exp_hosp_nps',
                criticalMomentInclude: [10251],//experiencia hospitalizacion id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            //imagenología
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - Imagenología',
                size: [2, 2],
                indicator: 'serv_neurof_csat',
                criticalMomentInclude: [12153],//imagenologia id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Imagenología',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_neurof_nps',
                criticalMomentInclude: [12153],//imagenologia id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            //resonancia magnetica
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - Resonancia Magnética',
                size: [2, 2],
                indicator: 'serv_neurof_csat',
                criticalMomentInclude: [12152],//diagnostico de resonancia id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Resonancia Magnética',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_neurof_nps',
                criticalMomentInclude: [12152],//diagnostico de resonancia id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            //neurofisiologia
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - Neurofisiología',
                size: [2, 2],
                indicator: 'serv_neurof_csat',
                criticalMomentInclude: [10256],//Área de diagnóstico de Neurofisiología id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Neurofisiología',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_neurof_nps',
                criticalMomentInclude: [10256],//Área de diagnóstico de Neurofisiología id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            //cirugia ambulatoria
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - Cirugía Ambulatoria',
                size: [2, 2]    ,
                indicator: 'serv_clin_csat',
                criticalMomentInclude: [10257],//cirugia ambulatoria id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Cirugía Ambulatoria',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_clin_nps',
                criticalMomentInclude: [10257],//cirugia ambulatoria id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            //oncologia
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - Oncología',
                size: [2, 2]    ,
                indicator: 'serv_clin_csat',
                criticalMomentInclude: [12151],//oncologia id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Oncología',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_clin_nps',
                criticalMomentInclude: [12151],//oncologia id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),
            //urologia
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - Urología',
                size: [2, 2]    ,
                indicator: 'serv_clin_csat',
                criticalMomentInclude: [12101],//urologia id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Urología',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_clin_nps',
                criticalMomentInclude: [12101],//urologia id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            //gastroenterologia /* ENDOSCOOPIA
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - Endoscopía',
                size: [2, 2],
                indicator: 'serv_end_csat',
                criticalMomentInclude: [10258],//endoscopia id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Endoscopía',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_end_nps',
                criticalMomentInclude: [10258],//endoscopia id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            //medicina en reahabilitacioin
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Satisfacción General - Medicina de Rehabilitación',
                size: [2, 2],
                indicator: 'serv_rehab_csat',
                criticalMomentInclude: [10259],//rehabilitacion id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                },
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Medicina de Rehabilitación',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_rehab_nps',
                criticalMomentInclude: [10259],//rehabilitacion id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),
            
            //CIDyT
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - Servicios de diagnóstico CIDYT',
                size: [2, 2],
                indicator: 'serv_cidyt_csat',
                criticalMomentInclude: [10263],//diagnostico CIDYT id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Servicios de diagnóstico CIDYT',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_cidyt_nps',
                criticalMomentInclude: [10263],//diagnostico CIDYT id
                mapper: (data, extra) => {
                    //console.log('nps cidit')
                    //console.log(data)
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0,
                }
            }),

            //laboratorio
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General - Servicios de laboratorio',
                size: [2, 2],
                indicator: 'serv_lab_csat',
                criticalMomentInclude: [10260],//laboratorio id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Servicios de laboratorio',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_lab_nps',
                criticalMomentInclude: [10260],//laboratorio id
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),

            //radioterapia
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Satisfacción General - Servicios de Radioterapia',
                size: [2, 2],
                indicator: 'serv_rad_csat',
                criticalMomentInclude: [10262],//radioterapia id
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS - Servicios de Radioterapia',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                criticalMomentInclude: [10262],//radioterapia id
                indicator: 'serv_rad_nps',
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),
            //END critical moments listed



            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'stackedBarAlertManagement',
                title: 'Tiempos de Respuesta en Gestión de Alertas',
                size: [4, 1],
                indicator: 'alert-management-time'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByTag',
                title: 'Clasificación de las quejas',
                key: 'bar-by-tag-word-count',
                size: [4, 2]
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByCategory',
                title: 'Principales servicios o áreas responsables de las quejas',
                key: 'bar-by-tag-word-count',
                indicator: 'SENTIMENT',
                size: [4, 2]
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                title: 'Diagrama de Ishikawa',
                name: 'diagramaIshikawa',
                size: [4, 2],
                indicator: 'sentiment',
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lineByMonthAndCategory',
                title: 'Numero de quejas de las principales causas',
                key: 'line-by-month-and-category',
                indicator: 'SENTIMENT',
                size: [4, 2]
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                title: 'Servicios a Pacientes y Familiares',
                size: [4, 3],
                indicator: 'SENTIMENT',
                extraConfigs: {
                    groupLabels: {
                        positive: 'Positivos',
                        negative: 'Negativos',
                        neutral: 'Neutros',
                    }
                }

            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGenericByStatus',
                title: 'Porcentaje de respuestas',
                indicator: 'general-respuestas-gauge',
                mapper: msurPorcRespuestasMapper,
                tooltipFormatter: msurTooltipTotalRegistros,
                size: [1, 2],
                //criticalMomentInclude: [getCmID('venta')],
                url: 'dashboard/status',
                extraIndicatorConfigs: {
                    keyExtract: ['resume'],
                    singleton: true
                },
                extras: {
                    useLcmApi: true,
                    //workflowName: 'posterior_dos'
                },
                extraConfigs: {
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'wordCount',
                title: 'Comentarios',
                size: [3, 2],
                indicator: 'WORD_COUNT',

            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lastComments',
                size: [2, 2],
                indicator: 'COMMENTS',
                extraConfigs: {
                    maxCommentSize: 120
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'rankingByTagBest',
                title: 'Sentimiento positivo con más frecuencia',
                size: [2, 1],
                indicator: 'SENTIMENT',
                extras: {
                    trunc: 'HALF_DOWN',
                    topSize: 3,
                },
                extraConfigs: {
                    color: DEFAULT_COLORS_BY_NAME.VERDE
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'rankingByTagWorst',
                title: 'Sentimiento negativo con más frecuencia',
                size: [2, 1],
                indicator: 'SENTIMENT',
                extras: {
                    trunc: 'HALF_UP',
                    bottomSize: 3,
                },
                extraConfigs: {
                    color: DEFAULT_COLORS_BY_NAME.ROJO
                }
            }),
            /*
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'diagramaIshikawa',
                title: 'Diagrama de Ishikawa',
                size: [4, 4],
                indicator: 'SENTIMENT',

            }),
            */
        ]
    },
} as DasboardConfig
